// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import $ from 'jquery' ;
import 'bootstrap'
import '../css/bootstrap.min.css'
import '../js/bootstrap.min.js'
import BaiduMap from 'vue-baidu-map'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import axios from 'axios';
import 'wowjs/css/libs/animate.css'
import 'animate.css'


Vue.prototype.$axios = axios;
import QS from 'qs'
Vue.prototype.qs = QS;

Vue.prototype.axios = axios
Vue.use(Viewer)
Viewer.setDefaults({
  Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})
router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
})



Vue.use(ElementUI);
Vue.use(BaiduMap, {
  ak: 'eDHRNs8zTL7PLX48sB5H1meRoBhya1Do'    //密钥
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js